import React, { FC, memo } from 'react';
import { useStyles } from './styles';

export interface RequiredStarProps {
  hasVn: boolean;
}

const RequiredStar: FC<RequiredStarProps> = ({ hasVn }) => {
  const classes = useStyles([hasVn]);
  return <div className={classes.requiredStar}>*</div>;
};

export default memo(RequiredStar);
